import React, {useEffect, useState} from "react";
import {diff} from "deep-diff";
import {cqAPI, getBid} from "../../lib/Auth";
import dialogManager from "../DialogManager/DialogManager";

const _ = require("lodash");
import {
  Box,
  Flex,
  Button,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  useColorMode,
  Checkbox,
  IconButton,
  useToast,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Select,
  SimpleGrid,
  Text,
  useTheme,
  useColorModeValue,
  Spacer,
  Link
} from "@chakra-ui/react";
import ReactSelect from "react-select";
import EditableText from "../EditableText/EditableText";
import { AddIcon, DeleteIcon, CheckIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import {WORKER_DENTICON, WORKER_DENTRIX} from "../AdapterSetting/constants";

const nonConfigurablePatientTypeForServices = ["0", "1"];
const nonConfigurableServices = ["1"];
const requiresPrimaryProvider = ["0"]

const BookingSettings = () => {
  console.log("lololol")
  const [settings, setSettings] = useState({
    non_standard_services: [],
    service_links: [],
    employees: [],
    options: {},
  });
  const {colorMode} = useColorMode();
  const [originalSettings, setOriginalSettings] = useState({
    non_standard_services: [],
    service_links: [],
    employees: [],
    options: {},
  });

  const Hours = [
    7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14, 14.5,
    15, 15.5, 16, 16.5, 17, 17.5, 18, 18.5, 19, 19.5,
  ];
  const days = ["S", "M", "T", "W", "Th", "F", "S"];
  const theme = useTheme();
  const customStyles = {
    clearIndicator: (provided) => ({
      ...provided,
      display: "none", // This hides the clear indicator
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: theme.colors.gray[100],
      borderColor: theme.colors.gray[300],
      boxShadow: theme.shadows.sm,
      "&:hover": {
        borderColor: theme.colors.gray[400],
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: theme.colors.gray[50],
      width: "max-content",
      minWidth: "100%"
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? theme.colors.blue[100]
        : theme.colors.gray[50],
      color: theme.colors.gray[700],
      "&:hover": {
        backgroundColor: theme.colors.blue[50],
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      width: "200px"
    })
    // Add other style overrides as needed
  };
  const toast = useToast();
  const {isOpen, onOpen, onClose} = useDisclosure();
  const [newService, setNewService] = useState({
    name: "",
    duration: 30,
    patient_type: "n",
  });
  const [isDenticon, setIsDenticon] = useState(false);
  const [isDentrix, setIsDentrix] = useState(false);

  const fetchSettings = async () => {
    const response = await cqAPI.get("/settings/booking");
    if (response?.type === "ok") {
      switch (response.data.businesses[0]?.pms_type) {
        case WORKER_DENTICON:
          setIsDenticon(true);
          setIsDentrix(false);
          break;
        case WORKER_DENTRIX:
          setIsDenticon(false);
          setIsDentrix(true);
          break;
        default:
          setIsDenticon(false);
          setIsDentrix(false);
      }
      setSettings(response.data);
      setOriginalSettings(_.cloneDeep(response.data));
    }
  };

  useEffect(() => {
    fetchSettings().catch(console.error);
  }, []);

  const updateService = async (service, field, value) => {
    const resp = await cqAPI.put("/settings/booking/service", {
      field: field,
      value: value,
      sid: service.id,
    });
    if (resp?.type === "ok") {
      setSettings({
        ...settings,
        non_standard_services: settings.non_standard_services.map((x) => {
          if (x.id === service.id) {
            x[field] = value;
          }
          return x;
        }),
      });
      return true;
    }
    return false;
  };

  const saveNewService = async () => {
    // Add service saving logic here
    const resp = await cqAPI.post("/settings/booking/service", newService);
    if (resp.type === "ok") {
      await fetchSettings();
      onClose();
    }
    if (resp.msg) {
      toast({
        title: "Error",
        description: resp.msg,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleNewServiceChange = (field, value) => {
    setNewService((prev) => ({...prev, [field]: value}));
  };

  const deleteService = async (sid) => {
    const resp = await cqAPI.del("/settings/booking/service", {sid});
    if (resp.type === "ok") {
      setSettings({
        ...settings,
        non_standard_services: settings.non_standard_services.filter((x) => {
          return x.id !== sid;
        }),
      });
    }
  };

  const handleServiceChange = (_employee, values) => {
    const newSettings = {
      ...settings,
      employees: settings.employees.map((employee) => {
        if (employee._id && employee._id === _employee._id) {
          employee.provider_info[settings.root_id] = employee.provider_info[settings.root_id] || {}
          employee.provider_info[settings.root_id].service_id = values;
        }
        return employee;
      }),
    };
    setSettings(newSettings);
  };

  const handlePMSProviderChange = (_employee, value) => {
    const newSettings = {
      ...settings,
      employees: settings.employees.map((employee) => {
        if (employee?._id === _employee._id) {
          employee.provider_info[settings.root_id] = employee.provider_info[settings.root_id] || {}
          employee.provider_info[settings.root_id].pms_provider_id = value;
        }
        return employee;
      }),
    };
    setSettings(newSettings);
  };

  const handleOperatoryChange = (_employee, newPatient, values) => {
    const newSettings = {
      ...settings,
      employees: settings.employees.map((employee) => {
        if (employee._id && employee._id === _employee._id) {
          employee.provider_info[settings.root_id] = employee.provider_info[settings.root_id] || {}
          if (newPatient) {
            employee.provider_info[settings.root_id].new_patient_operatory_ids = values;
          } else {
            employee.provider_info[settings.root_id].existing_patient_operatory_ids = values;
          }
        }
        return employee;
      }),
    };
    setSettings(newSettings);
  };

  const hasChanges = () => {
    return _.isEqual(originalSettings, settings);
  };

  const getValue = (path) =>
    path.reduce((acc, cur) => {
      return acc[cur];
    }, settings);

  const saveChanges = async () => {
    // You will need to define the API endpoint and payload structure as per your backend specifications
    const changes = [];
    const errors = [];
    const deletes = [];
    const providerServices = [];
    const providerNewPatientOperatories = [];
    const providerExistingPatientOperatories = [];
    const providerPMSProviderIds = [];
    diff(originalSettings, settings).forEach((change) => {
      let path = change.path;
      if (typeof change.path[change.path.length - 1] === "number") {
        path = change.path.slice(0, -1);
      } else {
        path = change.path;
      }
      const newValue = getValue(path);
      if (
        change.kind !== "D" &&
        (path[2] === "providerLunchHours" || path[2] === "providerWorkingHours")
      ) {
        if (
          (newValue[0] === -1 || newValue[1] === -1) &&
          (newValue[0] * newValue[1] < 0 || path[2] === "providerWorkingHours")
        ) {
          errors.push(
            path[2] === "providerLunchHours"
              ? "Either do not set lunch hour or set both from and to values."
              : "Either do not have a provider for a day or have both from and to times for which they work."
          );
          return;
        }
        if (path[2] === "providerWorkingHours" && !newValue.length) {
          errors.push(
            "Either do not have a provider for a day or have both from and to times for which they work."
          );
          return;
        }
        changes.push({
          pid: settings.employees[path[1]]._id,
          day: path[path.length - 1],
          bid: path[3],
          ...(path[2] === "providerLunchHours"
            ? {
              lunch: newValue,
            }
            : {
              hours: newValue,
            }),
        });
      } else {
        if (change.kind === "D") {
          if (
            !deletes.find(
              (x) =>
                x.pid === settings.employees[path[1]]._id &&
                x.day === path[path.length - 1] &&
                x.bid === path[3]
            )
          ) {
            deletes.push({
              pid: settings.employees[path[1]]._id,
              day: path[path.length - 1],
              bid: path[3],
            });
          }
        } else {
          if (
            (path[4] === 'service_id' || newValue.service_id) && !providerServices.find(
              (x) =>
                x.pid === settings.employees[path[1]]._id &&
                _.isEqual(x.service_id, newValue.service_id || newValue)
            )
          ) {
            providerServices.push({
              pid: settings.employees[path[1]]?._id || "",
              service_id: newValue.service_id || newValue,

            });
          }
          if (
            (path[4] === 'new_patient_operatory_ids' || newValue.new_patient_operatory_ids) && !providerNewPatientOperatories.find(
              (x) =>
                x.pid === settings.employees[path[1]]._id &&
                _.isEqual(x.new_patient_operatory_ids, newValue.new_patient_operatory_ids || newValue)
            )
          ) {
            providerNewPatientOperatories.push({
              pid: settings.employees[path[1]]?._id || "",
              new_patient_operatory_ids: newValue.new_patient_operatory_ids || newValue,
            });
          }

          if (
            (path[4] === 'existing_patient_operatory_ids' || newValue.existing_patient_operatory_ids) && !providerExistingPatientOperatories.find(
              (x) =>
                x.pid === settings.employees[path[1]]._id &&
                _.isEqual(x.existing_patient_operatory_ids, newValue.existing_patient_operatory_ids || newValue)
            )
          ) {
            providerExistingPatientOperatories.push({
              pid: settings.employees[path[1]]?._id || "",
              existing_patient_operatory_ids: newValue.existing_patient_operatory_ids || newValue,

            });
          }

          if (
            (path[4] === 'pms_provider_id' || newValue.pms_provider_id) && !providerPMSProviderIds.find(
              (x) =>
                x.pid === settings.employees[path[1]]._id &&
                _.isEqual(x.pms_provider_id, newValue.pms_provider_id || newValue)
            )
          ) {
            providerPMSProviderIds.push({
              pid: settings.employees[path[1]]?._id || "",
              pms_provider_id: newValue.pms_provider_id || newValue,
              bid: path[3]
            });
          }
        }
      }
    });
    if (errors.length) {
      toast({
        title: "Error",
        description: errors[0],
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    if (providerServices.length) {
      const result = await cqAPI.put(
        "/settings/booking/provider/services",
        providerServices
      );
      if (result.msg) {
        dialogManager.open({
          onDeny: () => {
          },
          acceptText: "OK",
          body: result.msg,
          header: "Error",
        });
        return;
      }
    }


    if (providerNewPatientOperatories.length) {
      const result = await cqAPI.put(
        "/settings/booking/provider/operatory/new",
        providerNewPatientOperatories
      );
      if (result.msg) {
        dialogManager.open({
          onDeny: () => {
          },
          acceptText: "OK",
          body: result.msg,
          header: "Error",
        });
        return;
      }
    }

    if (providerExistingPatientOperatories.length) {
      const result = await cqAPI.put(
        "/settings/booking/provider/operatory/exist",
        providerExistingPatientOperatories
      );

      if (result.msg) {
        dialogManager.open({
          onDeny: () => {
          },
          acceptText: "OK",
          body: result.msg,
          header: "Error",
        });
        return;
      }
    }

    if (providerPMSProviderIds.length) {
      const result = await cqAPI.put(
        "/settings/booking/provider/pms_provider_id",
        providerPMSProviderIds
      );
      if (result.msg) {
        dialogManager.open({
          onDeny: () => {
          },
          acceptText: "OK",
          body: result.msg,
          header: "Error",
        });
        return;
      }
    }


    if (changes.length) {
      const result = await cqAPI.put("/settings/booking/provider", changes);
      if (result.msg) {
        dialogManager.open({
          onDeny: () => {
          },
          acceptText: "OK",
          body: result.msg,
          header: "Error",
        });
        return;
      }
    }


    if (deletes.length) {
      const result = await cqAPI.del("/settings/booking/provider", deletes);
      if (result.msg) {
        dialogManager.open({
          onDeny: () => {
          },
          acceptText: "OK",
          body: result.msg,
          header: "Error",
        });
        return;
      }
    }
    await fetchSettings();
  };

  const getProviderHoursForDay = (providerWorkingHours, dayIndex) => {
    const bid = Object.keys(providerWorkingHours).find(
      (b) => b[String(dayIndex)] && b[String(dayIndex)].length
    );
    if (!bid) {
      return {};
    }
    return {hours: providerWorkingHours[bid][String(dayIndex)], bid};
  };

  const updateProviderBusinessForDay = (_employee, dayIndex, _bid) => {
    const newSettings = {
      ...settings,
      employees: settings.employees.map((employee) => {
        if (employee._id && employee._id === _employee._id) {
          const {bid} = getProviderHoursForDay(
            employee.providerWorkingHours,
            dayIndex
          );
          if (!_bid) {
            if (bid) {
              delete employee.providerWorkingHours[bid][String(dayIndex)];
              delete employee.providerLunchHours[bid][String(dayIndex)];
            } else {
              //should not happen
            }
          } else {
            if (bid) {
              if (bid !== _bid) {
                employee.providerWorkingHours[_bid][String(dayIndex)] =
                  employee.providerWorkingHours[bid][String(dayIndex)];
                delete employee.providerWorkingHours[bid][String(dayIndex)];
                delete employee.providerLunchHours[bid][String(dayIndex)];
              } else {
                employee.providerWorkingHours[_bid] =
                  employee.providerWorkingHours[_bid] || {};
                employee.providerLunchHours[_bid] =
                  employee.providerLunchHours[_bid] || {};
                employee.providerWorkingHours[_bid][String(dayIndex)] = [];
                employee.providerLunchHours[_bid][String(dayIndex)] = [];
              }
            } else {
              employee.providerWorkingHours[_bid] =
                employee.providerWorkingHours[_bid] || {};
              employee.providerLunchHours[_bid] =
                employee.providerLunchHours[_bid] || {};
              employee.providerWorkingHours[_bid][String(dayIndex)] = [];
              employee.providerLunchHours[_bid][String(dayIndex)] = [];
            }
          }
        }
        return employee;
      }),
    };
    setSettings(newSettings);
  };

  const updateProviderLunchForDay = (_employee, dayIndex, hourIndex, value) => {
    const newSettings = {
      ...settings,
      employees: settings.employees.map((employee) => {
        if (employee._id && employee._id === _employee._id) {
          const {bid} = getProviderHoursForDay(
            employee.providerLunchHours,
            dayIndex
          );
          employee.providerLunchHours[bid][String(dayIndex)] = employee
            .providerLunchHours[bid][String(dayIndex)] || [-1, -1];
          employee.providerLunchHours[bid][String(dayIndex)][hourIndex] =
            parseFloat(value);
        }
        return employee;
      }),
    };
    setSettings(newSettings);
  };

  const updateProviderHoursForDay = (_employee, dayIndex, hourIndex, value) => {
    const newSettings = {
      ...settings,
      employees: settings.employees.map((employee) => {
        if (employee._id && employee._id === _employee._id) {
          const {hours, bid} = getProviderHoursForDay(
            employee.providerWorkingHours,
            dayIndex
          );
          employee.providerWorkingHours[bid][String(dayIndex)] = employee
            .providerWorkingHours[bid][String(dayIndex)] || [-1, -1];
          employee.providerWorkingHours[bid][String(dayIndex)][hourIndex] =
            parseFloat(value);
        }
        return employee;
      }),
    };
    setSettings(newSettings);
  };

  const bgColor = useColorModeValue("gray.100", "gray.700");

  const updateOption = async (field, value) => {
    const resp = await cqAPI.put("/settings/booking", {field, value});
    if (resp.msg) {
      dialogManager.open({
        onDeny: () => {
        },
        acceptText: "OK",
        body: resp.msg,
        header: "Error",
      });
      return false;
    }
    setSettings({
      ...settings,
      options: {...settings.options, [field]: value},
    });
    setOriginalSettings({
      ...originalSettings,
      options: {...originalSettings.options, [field]: value},
    });
    return true;
  };

  const bid = getBid();

  const getProviderName = (prov) => {
    const name = `${prov.first_name} ${prov.last_name}`.trim();
    if (prov.specialty) {
      return `${prov.pms_id} ${name}, ${prov.specialty}`;
    }
    return `${prov.pms_id} ${name}`;
  }

  const getPrimaryProviderOptions = () => {
    return (
      (settings?.raw_providers && settings?.raw_providers[bid]) || []
    ).filter(
      prov => prov.primary
    ).map(
      prov => ({
        value: prov.pms_id, label: getProviderName(prov)
      })
    )
  };

  const getProviderOptions = () => {
    return (
      (settings?.raw_providers && settings?.raw_providers[bid]) || []
    ).map(
      prov => ({
        value: prov.pms_id, label: getProviderName(prov)
      })
    )
  };

  return (
    <Box p={4} overflowY="auto" height="100%" width="100%">
      <Tabs
        isFitted
        variant="enclosed"
        padding="8px 24px 24px 24px"
        bgColor={colorMode === "light" ? "#FFFFFF" : "#212330"}
        borderRadius="16px"
      >
        <TabList mb="1em">
          <Tab
            padding="0px 16px 16px 16px"
            border="none"
            _selected={{
              borderBottom: `4px solid ${
                colorMode === "light"
                  ? theme.colors.brand[300]
                  : theme.colors.lightBackground
              }`,
            }}
          >
            Services
          </Tab>
          <Tab
            padding="0px 16px 16px 16px"
            border="none"
            _selected={{
              borderBottom: `4px solid ${
                colorMode === "light"
                  ? theme.colors.brand[300]
                  : theme.colors.lightBackground
              }`,
            }}
          >
            Providers Schedule
          </Tab>
          <Tab
            padding="0px 16px 16px 16px"
            border="none"
            _selected={{
              borderBottom: `4px solid ${
                colorMode === "light"
                  ? theme.colors.brand[300]
                  : theme.colors.lightBackground
              }`,
            }}
          >
            Options
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Flex justifyContent="flex-end" mb={4}>
              <Button leftIcon={<AddIcon/>} onClick={onOpen}>
                Add Service
              </Button>
            </Flex>
            {settings?.non_standard_services && settings?.non_standard_services.map((service) => (
              <SimpleGrid
                className="service"
                key={service.id}
                savable="true"
                mb="2"
                padding="16px 24px 16px 24px"
                bgColor={bgColor}
                borderRadius="md"
                flexDirection={{base: "column", md: "row"}} // Responsive direction
                alignItems={{base: "flex-start", md: "center"}} // Align items based on screen size
              >
                <Flex flexWrap="wrap" display="flex">
                  <Flex minWidth="150px" width="250px" align="center">
                    <EditableText
                      initialValue={service.name}
                      onSave={(newValue) =>
                        updateService(service, "name", newValue.trim())
                      }
                      placeholder="Service Name"
                      pattern={/^.{3,}/}
                      invalid="more than 3 character."
                      editable={!/^([0123])$/.test(service.id)}
                    />
                  </Flex>
                  <Flex minWidth="150px" maxWidth="200px" paddingLeft="40px" align="center">
                    {!nonConfigurableServices.includes(service.id) && (
                      <EditableText
                        initialValue={service.duration}
                        onSave={(newValue) =>
                          updateService(service, "duration", parseInt(newValue))
                        }
                        placeholder="Duration"
                        pattern={/^[0-9]{1,3}$/}  // allow positive numbers up to 3 digits
                        invalid="Numbers only (up to 3 digits)"
                      />
                    )}
                  </Flex>
                  <Flex pl="40px" justifyContent="flex-end" align="center">
                    <ReactSelect
                      placeholder="Appointment Type"
                      styles={customStyles}
                      isMulti
                      options={(
                        (settings?.raw_appointment_types && settings?.raw_appointment_types[bid]) || []
                      ).map(
                        apt => ({value: apt.pms_id, label: apt.name})
                      )}
                      value={(
                        (settings?.raw_appointment_types && settings?.raw_appointment_types[bid]) || []
                      ).filter(
                          apt => (service.appointment_types || []).includes(apt.pms_id)
                        ).map(apt => ({value: apt.pms_id, label: apt.name})
                      )}
                      onChange={e => updateService(
                        service,
                        "appointment_types",
                        e.map(v => v.value)
                      )}
                    />
                  </Flex>
                  {!nonConfigurablePatientTypeForServices.includes(service.id) && (
                    <Flex flexGrow={1} justifyContent="center" align="center">

                        <RadioGroup
                          defaultValue={service.patient_type}
                          onChange={(e) =>
                            updateService(service, "patient_type", e)
                          }
                        >
                          <Stack direction="row" pt="1.25" pl="6.25">
                            <Radio value="n">New Patients</Radio>
                            <Radio value="e">Existing Patients</Radio>
                            <Radio value="ne">Both</Radio>
                          </Stack>
                        </RadioGroup>
                    </Flex>
                  )}
                  {isDentrix && requiresPrimaryProvider.includes(service.id) && (
                    <Flex flexGrow={1} justifyContent="center" align="left">
                      <ReactSelect
                        placeholder="Primary Provider"
                        styles={customStyles}
                        options={getPrimaryProviderOptions()}
                        value={getPrimaryProviderOptions().filter(
                          prov => (service.primary_provider_pms_id && service.primary_provider_pms_id === prov.value)
                        )}
                        onChange={e => updateService(
                          service,
                          "primary_provider_pms_id",
                          e.value
                        )}
                      />
                    </Flex>
                  )}
                  <Flex ml="auto" pr="20px" align="center">
                    {!nonConfigurableServices.includes(service.id) && (
                      <>
                        <Switch
                          isChecked={service.enabled}
                          float="right"
                          pt="1.25"
                          pl="6.25"
                          onChange={(e) =>
                            updateService(service, "enabled", e.target.checked)
                          }
                        >
                        </Switch>
                        <Text ml={2}>Enabled</Text>
                      </>
                    )}
                  </Flex>
                  <Flex minWidth="40px" align="center">
                    {!["0", "1", "2", "3"].includes(service.id) && (
                      <IconButton
                        aria-label="Delete service"
                        icon={<DeleteIcon/>}
                        size="sm"
                        onClick={() => deleteService(service.id)} // Implement your deletion logic here
                        ml="2" // For a little spacing from the checkbox
                        colorScheme="red"
                      />
                    )}
                  </Flex>
                </Flex>
              </SimpleGrid>
            ))}
          </TabPanel>
          <TabPanel>
            <Flex justifyContent="flex-end" mb={4}>
              <Button
                leftIcon={<CheckIcon/>}
                onClick={saveChanges}
                isDisabled={hasChanges()}
              >
                Save Changes
              </Button>
            </Flex>
            <SimpleGrid columns={{base: 1, md: 1, lg: 1}} spacing="20px">
              {settings?.employees && settings.employees.map((employee, index) => (
                <Box
                  key={index}
                  borderWidth="1px"
                  borderRadius="lg"
                  mb={4}
                  width="100%"
                  paddingBottom="15px"
                >
                  <Box
                    bg={employee._id ? "blue.500" : "gray.500"}
                    color="white"
                    p={4}
                    borderTopRadius="lg"
                  >
                    <Flex justifyContent="space-between">
                      {employee._id && (
                        <Flex direction="column" width="100%">
                          <Flex mb={1}>
                            <Box>
                              {employee.name} - Hired:{" "}
                              {new Date(employee.created).toLocaleDateString()}
                            </Box>
                            <Spacer/>
                            <Flex justifyContent="flex-end" gap={8}>

                              Provider:
                              <ReactSelect
                                onChange={(e) => handlePMSProviderChange(
                                  employee,
                                  e.value
                                )}
                                styles={customStyles}
                                options={getProviderOptions()}
                                value={getProviderOptions()
                                  .find(
                                    provider =>
                                      provider.value === employee?.provider_info[settings.root_id]?.pms_provider_id
                                  )
                                }
                              />
                            </Flex>
                          </Flex>

                          <Flex justifyContent="flex-end" p={1} gap={8}>

                            Services:
                            <ReactSelect
                              onChange={(e) => {
                                handleServiceChange(
                                  employee,
                                  e.map((option) => option.value)
                                );
                              }}
                              styles={customStyles}
                              isMulti
                              options={settings.root_services.map(
                                (service) => ({
                                  value: service.id,
                                  label: service.name,
                                })
                              )}
                              value={(
                                (employee.provider_info &&
                                  settings.root_id &&
                                  employee.provider_info[settings.root_id] &&
                                  employee.provider_info[settings.root_id]
                                    .service_id) ||
                                []
                              )
                                .map((sid) => {
                                  const s = settings.root_services.find(
                                    (i) => i.id === sid
                                  );
                                  if (!s) {
                                    return;
                                  }
                                  return {
                                    value: s.id,
                                    label: s.name,
                                  };
                                })
                                .filter((x) => !!x)}
                            />
                          </Flex>
                          <Flex justifyContent="flex-end" p={1} gap={8}>

                            New Patient Operatories:
                            <ReactSelect
                              onChange={(e) => {
                                handleOperatoryChange(
                                  employee,
                                  true,
                                  e.map((option) => option.value)
                                );
                              }}
                              styles={customStyles}
                              isMulti
                              options={settings.root_operatories.map(
                                (operatory) => ({
                                  value: operatory.id,
                                  label: operatory.name,
                                })
                              )}
                              value={(
                                (employee.provider_info &&
                                  settings.root_id &&
                                  employee.provider_info[settings.root_id] &&
                                  employee.provider_info[settings.root_id]
                                    .new_patient_operatory_ids) ||
                                []
                              )
                                .map((sid) => {
                                  const s = settings.root_operatories.find(
                                    (i) => i.id === sid
                                  );
                                  if (!s) {
                                    return;
                                  }
                                  return {
                                    value: s.id,
                                    label: s.name,
                                  };
                                })
                                .filter((x) => !!x)}
                            />
                          </Flex>
                          <Flex justifyContent="flex-end" p={1} gap={8}>

                            Existing Patient Operatories:
                            <ReactSelect
                              onChange={(e) => {
                                handleOperatoryChange(
                                  employee,
                                  false,
                                  e.map((option) => option.value)
                                );
                              }}
                              styles={customStyles}
                              isMulti
                              options={settings.root_operatories.map(
                                (operatory) => ({
                                  value: operatory.id,
                                  label: operatory.name,
                                })
                              )}
                              value={(
                                (employee.provider_info &&
                                  settings.root_id &&
                                  employee.provider_info[settings.root_id] &&
                                  employee.provider_info[settings.root_id]
                                    .existing_patient_operatory_ids) ||
                                []
                              )
                                .map((sid) => {
                                  const s = settings.root_operatories.find(
                                    (i) => i.id === sid
                                  );
                                  if (!s) {
                                    return;
                                  }
                                  return {
                                    value: s.id,
                                    label: s.name,
                                  };
                                })
                                .filter((x) => !!x)}
                            />
                          </Flex>
                        </Flex>
                      )}
                    </Flex>
                  </Box>
                  {!isDenticon && employee._id &&
                    days.map((day, dayIndex) => {
                      const {hours, bid} = getProviderHoursForDay(
                        employee.providerWorkingHours,
                        dayIndex
                      );
                      const lunch = getProviderHoursForDay(
                        employee.providerLunchHours,
                        dayIndex
                      );
                      return (
                        <Flex key={dayIndex} mt={2}>
                          <Text minWidth="50px">{day}</Text>
                          <Select
                            width="300px"
                            placeholder="Select business"
                            value={hours && bid}
                            onChange={(e) =>
                              updateProviderBusinessForDay(
                                employee,
                                dayIndex,
                                e.target.value
                              )
                            }
                          >
                            {settings.businesses.map((business) => (
                              <option key={business.id} value={business.id}>
                                {business.name}
                              </option>
                            ))}
                          </Select>
                          <Text paddingTop="10px" paddingLeft="10px">
                            From:{" "}
                          </Text>
                          <Select
                            marginLeft="10px"
                            isDisabled={bid && hours ? false : true}
                            width="85px"
                            value={(hours && hours[0]) || -1}
                            onChange={(e) =>
                              updateProviderHoursForDay(
                                employee,
                                dayIndex,
                                0,
                                e.target.value
                              )
                            }
                          >
                            <option value={-1}>Select</option>
                            {Hours.map((hour) => (
                              <option key={hour} value={hour}>
                                {hour}
                              </option>
                            ))}
                          </Select>
                          <Text paddingTop="10px" paddingLeft="10px">
                            To:{" "}
                          </Text>
                          <Select
                            marginLeft="10px"
                            isDisabled={bid && hours ? false : true}
                            onChange={(e) =>
                              updateProviderHoursForDay(
                                employee,
                                dayIndex,
                                1,
                                e.target.value
                              )
                            }
                            value={(hours && hours[1]) || -1}
                            width="85px"
                          >
                            <option value={-1}>Select</option>
                            {Hours.map((hour) => (
                              <option key={hour} value={hour}>
                                {hour}
                              </option>
                            ))}
                          </Select>
                          <Text paddingTop="10px" paddingLeft="10px">
                            Lunch from:{" "}
                          </Text>
                          <Select
                            marginLeft="10px"
                            isDisabled={bid && hours ? false : true}
                            onChange={(e) =>
                              updateProviderLunchForDay(
                                employee,
                                dayIndex,
                                0,
                                e.target.value
                              )
                            }
                            value={(lunch.hours && lunch.hours[0]) || -1}
                            width="85px"
                          >
                            <option value={-1}>Select</option>
                            {Hours.map((hour) => (
                              <option key={hour} value={hour}>
                                {hour}
                              </option>
                            ))}
                          </Select>
                          <Text paddingTop="10px" paddingLeft="10px">
                            To:{" "}
                          </Text>
                          <Select
                            marginLeft="10px"
                            isDisabled={bid && hours ? false : true}
                            onChange={(e) =>
                              updateProviderLunchForDay(
                                employee,
                                dayIndex,
                                1,
                                e.target.value
                              )
                            }
                            value={(lunch.hours && lunch.hours[1]) || -1}
                            width="85px"
                          >
                            <option value={-1}>Select</option>
                            {Hours.map((hour) => (
                              <option key={hour} value={hour}>
                                {hour}
                              </option>
                            ))}
                          </Select>
                        </Flex>
                      );
                    })}
                  {isDenticon && employee._id &&
                    <Link
                      href="https://support.planetdds.com/hc/en-us/articles/360045117292-How-do-we-add-or-modify-schedule-templates-for-providers"
                      target="_blank">
                      <br/> Click Here for more info on how to update the schedule!
                      <ExternalLinkIcon mx="2px"/>
                    </Link>}
                </Box>
              ))}
            </SimpleGrid>
          </TabPanel>
          <TabPanel>
            <Stack spacing={4}>
              <Flex
                align="center"
                justify="space-between"
                bgColor={bgColor}
                padding="20px 10px"
                borderRadius="md"
              >
                <Text minWidth="300px">
                  Initial exams include a subsequent hygiene visit
                </Text>
                <Checkbox
                  isChecked={settings?.options?.new_patient_followed_by_hygiene}
                  onChange={(e) =>
                    updateOption(
                      "new_patient_followed_by_hygiene",
                      e.target.checked
                    )
                  }
                />
              </Flex>
              <Flex
                align="center"
                justify="space-between"
                bgColor={bgColor}
                padding="20px 10px"
                borderRadius="md"
              >
                <Text minWidth="300px">
                  Overlap Ratio: Set above 100 to permit overlapping
                  appointments, such as 200 for full double-booking.
                </Text>
                <Flex width="150px" align="center">
                  <EditableText
                    onSave={(newValue) =>
                      updateOption("overlap_ratio", parseInt(newValue))
                    }
                    initialValue={settings?.options?.overlap_ratio}
                    placeholder="Overlap Ratio"
                    pattern={/^\d{1,3}$/}
                    invalid="more than 3 character."
                  />
                </Flex>
              </Flex>
              <Flex
                align="center"
                justify="space-between"
                bgColor={bgColor}
                padding="20px 10px"
                borderRadius="md"
              >
                <Text minWidth="300px" textAlign="left">
                  Signup Message: Displayed to new patients when booking their
                  appointment.
                </Text>
                <Flex width="300px" align="center">
                  <EditableText
                    onSave={(newValue) => updateOption("ols_message", newValue)}
                    initialValue={settings?.options?.ols_message}
                    placeholder="Signup Message"
                  />
                </Flex>
              </Flex>
            </Stack>
          </TabPanel>
        </TabPanels>
      </Tabs>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay/>
        <ModalContent>
          <ModalHeader>Add a New Service</ModalHeader>
          <ModalCloseButton/>
          <ModalBody>
            <Stack spacing={4}>
              <Input
                placeholder="Service Name"
                value={newService.name}
                onChange={(e) => handleNewServiceChange("name", e.target.value)}
              />
              <Input
                placeholder="Duration (in minutes)"
                type="number"
                value={newService.duration}
                onChange={(e) =>
                  handleNewServiceChange("duration", parseInt(e.target.value))
                }
              />
              <RadioGroup
                onChange={(value) =>
                  handleNewServiceChange("patient_type", value)
                }
                value={newService.patient_type}
              >
                <Stack direction="row">
                  <Radio value="n">New Patients</Radio>
                  <Radio value="e">Existing Patients</Radio>
                  <Radio value="ne">Both</Radio>
                </Stack>
              </RadioGroup>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={saveNewService}>
              Save
            </Button>
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default BookingSettings;
